export default __webpack_public_path__ + "static/media/category1.a76872d2.png";